import { AI_BOT_USER_NAME } from 'shared/constants/ai'

import { RootState } from '../../../../shared/config/store'

export const userStateSelector = (state: RootState) => state.user

export const userSelector = (state: RootState) => state.user.user

export const userAvatarUrlSelector = (state: RootState) => state.user.user?._links?.avatars?.href

export const tokenSelector = (state: RootState) => state.user.token

export const isAuthSelector = (state: RootState): boolean => !!state.user.token

export const userSettingsSelector = (state: RootState) => state.user.userSettings

export const userSettingByPathSelector = (state: RootState, path: string) => {
  const userSettings = state.user.userSettings

  if (userSettings && Array.isArray(userSettings)) {
    return userSettings.find((setting: any) => setting.path === path)
  }

  return null
}

export const rootBoardIdSelector = (state: RootState) => state.user.rootBoardId

export const assetRootBoardIdSelector = (state: RootState) => state.user.assetRootBoardId

export const userIdSelector = (state: RootState) => state.user.user?.id

export const userFamilyIdSelector = (state: RootState) => state.user.user?.family_user_id

export const userHasPasswordSelector = (state: RootState) => state.user.user?.has_password

export const getUiTheme = state => state.user.uiTheme

export const getUserRole = state => state.user.role

export const getAIAssistantName = (state: RootState): string => {
  const userSettings = state.user.userSettings
  const AI_ASSISTANT_SETTING_PATH = 'ai_assistant'
  if (userSettings && Array.isArray(userSettings)) {
    const aiAssistantSetting = userSettings.find((setting: any) => setting.path === AI_ASSISTANT_SETTING_PATH)
    if (aiAssistantSetting?.value?.assistant_name) {
      return aiAssistantSetting.value.assistant_name
    }
  }
  return AI_BOT_USER_NAME
}

export const getUserAvatarUrl = (state: RootState) => state.user.avatarUrl

export const getUserAvatarUploadUrlTmpl = (state: RootState) => state.user.avatarUploadUrlTmpl

export const getUserLocalAvatarUrl = (state: RootState) => state.user.localAvatarUrl

export const getFamilyUserData = (state: RootState) => state.user.familyUserData